import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import colors from '../../../../themes/main-colors';

interface Props {
  title: string;
  xOffset: string;
  height?: string;
  width?: string;
}

const ReportOutageIcon: React.FC<Props> = ({
  title,
  xOffset,
  height = '78',
  width = '78',
}: Props) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      a: {
        fill: '#eb7100',
      },

      b: {
        fill: '#fff',
      },

      c: {
        stroke: '#fff',
        fill: 'none',
      },

      d: {
        fill: '#fff',
        fontSize: '10px',
        fontFamily: 'Untitled-Sans',
        fontWeight: 500,
      },

      e: {
        filter: 'url(#a)',
      },

      reportOutageButtonMobileAppIcon: {
        '& .a': {
          fill: colors.orange,
          opacity: 1,
        },
        '& .b': {
          fill: colors.white,
          stroke: colors.white,
        },
        '& .d': {
          fontSize: '.625rem',
          fontWeight: 500,
        },
      },
    }),
  );
  const classes = useStyles();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 78 78"
    >
      <defs>
        <filter
          id="a"
          x="0"
          y="0"
          width="78"
          height="78"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="b" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="translate(9 6)">
        <g className={classes.e} transform="matrix(1, 0, 0, 1, -9, -6)">
          <circle
            className={classes.a}
            cx="30"
            cy="30"
            r="30"
            transform="translate(9 6)"
          />
        </g>
        <g transform="translate(-1.874 -1)">
          <path
            className={classes.b}
            d="M2663.462,2091.823l-5.541,7.417,1.4-11.161-9.171-.6,3.981-5.194Z"
            transform="translate(-2628.631 -2059.307)"
          />
          <path
            className={classes.b}
            d="M2655.977,2079.191l6.279-7.966-1.308,11.509,9.243.276-4.118,5.823Z"
            transform="translate(-2627.742 -2060.995)"
          />
          <path
            className={classes.c}
            d="M2646.861,2072.629l28.293,27.628"
            transform="translate(-2629.134 -2060.78)"
          />
        </g>
        <text className={classes.d} transform="translate(31 50)">
          <tspan x={xOffset} y="0" data-testid="tspan">
            {title}
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default ReportOutageIcon;
